import { z } from 'zod';

const VenueTypesQuery = z.array(z.object({
    Id: z.number(),
    VenueName: z.string()
}));

export { VenueTypesQuery };